import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn} from '@angular/router';
import {MessageTranslateService} from "@shared/services";

export const initI18nLanguages: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> => {
  const translateService = inject(MessageTranslateService);
  return translateService.initLanguages().pipe(map(() => true));
}
